var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-eac1d4a8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "container" };
var _hoisted_2 = { class: "header shadow-custom rounded-lg pt-14 lg:pt-28 pb-7 px-10 text-white" };
var _hoisted_3 = {
    key: 1,
    class: "background rounded-lg"
};
var _hoisted_4 = { class: "flex flex-col md:flex-row justify-center md:justify-between gap-y-2 md:gap-y-0 items-center md:items-end mb-5" };
var _hoisted_5 = { class: "flex flex-col lg:flex-row items-center text-center lg:text-left" };
var _hoisted_6 = { class: "text-3xl font-semibold" };
var _hoisted_7 = { class: "flex items-end gap-x-7" };
var _hoisted_8 = {
    key: 0,
    class: "flex items-center"
};
var _hoisted_9 = {
    key: 1,
    class: "flex items-center"
};
import { CoreStore } from '@student/modules/store';
import { computed, onMounted, ref } from 'vue';
import EAvatar from '@common/ui/EAvatar/EAvatar.vue';
import ProgressLine from '@common/ui/ProgressLine.vue';
import Api from '@student/modules/api/api';
import EIcon from '@common/ui/EIcon.vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LibraryHeader',
    setup: function (__props) {
        var _this = this;
        var t = useI18n().t;
        var user = computed(function () { return CoreStore.user; });
        var school = computed(function () { return CoreStore.school; });
        var studentProgress = ref({
            course: {
                count: 0,
                successFinished: 0
            },
            // webinar: {
            //     count: 0,
            //     successFinished: 0
            // },
            certificate: {
                count: 0
            }
        });
        var percentage = computed(function () {
            return (studentProgress.value.course.successFinished)
                / (studentProgress.value.course.count) * 100;
        });
        var courseNumeralizeText = computed(function () {
            return t('courseNumeralizeText', studentProgress.value.course.count);
        });
        // const webinarNumeralizeText = computed(() =>
        //     t('webinarNumeralizeText', { n: studentProgress.value.webinar.count })
        // )
        var certificateNumeralizeText = computed(function () {
            return t('certificateNumeralizeText', studentProgress.value.certificate.count);
        });
        var getStudentProgress = function () { return __awaiter(_this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Api.getStudentProgress()];
                    case 1:
                        data = (_a.sent()).data;
                        studentProgress.value = __assign({}, data);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getStudentProgress()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        //Плюрализм
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    (school.value.cover)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: _normalizeStyle({ 'backgroundImage': 'url(' + school.value.cover + ')' }),
                            class: "background rounded-lg"
                        }, null, 4))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(EAvatar, {
                                "color-id": user.value.id,
                                name: user.value.name || user.value.email,
                                src: user.value.avatar,
                                class: "mr-5"
                            }, null, 8, ["color-id", "name", "src"]),
                            _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('library.title')), 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(t)('library.description')), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            (studentProgress.value.course.count > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(EIcon, {
                                        class: "w-4 h-4 text-primary mr-2.5",
                                        icon: "layer2"
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(studentProgress.value.course.successFinished) + "/" + _toDisplayString(studentProgress.value.course.count) + " " + _toDisplayString(courseNumeralizeText.value), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (studentProgress.value.certificate.count)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createVNode(EIcon, {
                                        class: "w-4 h-4 text-primary mr-2.5",
                                        icon: "certificate"
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(studentProgress.value.certificate.count) + " " + _toDisplayString(certificateNumeralizeText.value), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createVNode(ProgressLine, {
                        percentage: percentage.value,
                        "background-color": "rgba(255, 255, 255, .15)",
                        color: "#17B198"
                    }, null, 8, ["percentage"])
                ])
            ]));
        };
    }
});
